import { rangePresets, defaultRangePreset } from '@gogame/intl-ts';
import { object, array, string, number } from '@gogame/schemas';

import {
  FILTER_CREATED,
  FILTER_ACTIVITY,
  FILTER_ACTIVITY_TYPES,
  // FILTER_TYPES,
  FILTER_STATUSES,
  FILTER_APPLICATIONS,
  FILTER_PLATFORMS,
  FILTER_REWARDS,
  FILTER_REQUESTED_BY,
  FILTER_ATTRIBUTION,
} from 'scenes/PromoCodes/constants';

export const EMPTY_FILTERS = {
  [FILTER_CREATED]: rangePresets.LAST_90_DAYS.value,
};

export const filtersSchema = object({
  [FILTER_CREATED]: array(string()).constants(defaultRangePreset),
  [FILTER_ACTIVITY]: array(string()).constants(defaultRangePreset),
  [FILTER_ACTIVITY_TYPES]: array(number()),
  // [FILTER_TYPES]: array(number()),
  [FILTER_ATTRIBUTION]: array(number()),
  [FILTER_STATUSES]: array(number()),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_PLATFORMS]: array(number()),
  [FILTER_REWARDS]: array(number()),
  [FILTER_REQUESTED_BY]: array(number()),
}).default({
  [FILTER_CREATED]: rangePresets.LAST_90_DAYS.value,
});
